export default __webpack_public_path__ + "static/media/gototop.f99ea55b.png";